import { EXPENSE_ACTION_TYPES } from '../../actions/expense/expense_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const expenses = (state = initialState, action) => {
    switch (action.type) {
        case EXPENSE_ACTION_TYPES.GET_EXPENSES_SUCCESS:
            return { ...state, collection: action.payload };
        case EXPENSE_ACTION_TYPES.POST_EXPENSE_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case EXPENSE_ACTION_TYPES.PUT_EXPENSE_SUCCESS:
            const updatedExpense = action.payload;
            return { ...state, collection: state.collection.map((expense) => expense.uuid !== updatedExpense.uuid ? expense : { ...expense, ...updatedExpense }) };
        case EXPENSE_ACTION_TYPES.UPDATE_EXPENSES_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
